import React from 'react'

const NoMatch = () => {
  return (
    <h1>404 - Blame it on the boogie</h1>
  )
}

export default NoMatch



/** WEBPACK FOOTER **
 ** ./src/app/components/shared/noMatch.jsx
 **/